import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import './LegalPage.css';

const documents = {
  privacy: {
    title: 'Политика конфиденциальности',
    intro: 'Как ЗЕМА получает, использует и защищает данные пользователей платформы.',
    sections: [
      ['Какие данные обрабатываются', 'Имя, фамилия, электронная почта, сведения об объектах недвижимости, проекты оценки и технические данные, которые пользователь добровольно передаёт через интерфейс платформы.'],
      ['Для чего нужны данные', 'Для регистрации и входа, сохранения проектов, подготовки предварительных расчётов, поддержки пользователей и обеспечения безопасности сервиса.'],
      ['Хранение и защита', 'Доступ к данным ограничивается задачами работы платформы. Применяются организационные и технические меры против неправомерного доступа, изменения и раскрытия.'],
      ['Права пользователя', 'Пользователь может запросить уточнение, ограничение обработки или удаление своих данных, направив обращение по контактному адресу ЗЕМА.'],
    ],
  },
  consent: {
    title: 'Согласие на обработку данных',
    intro: 'Условия согласия, которое пользователь подтверждает при создании аккаунта.',
    sections: [
      ['Состав согласия', 'Пользователь разрешает обработку данных, введённых в регистрационной форме и переданных при работе с проектами оценки.'],
      ['Способы обработки', 'Сбор, систематизация, хранение, уточнение и использование данных в объёме, необходимом для работы функций ЗЕМА.'],
      ['Срок действия', 'Согласие действует в течение использования платформы и может быть отозвано обращением по электронной почте. Отзыв не отменяет обработку, выполненную на законных основаниях до его получения.'],
      ['Связь', 'Вопросы по обработке данных принимаются по адресу Voronova.anastasiya99@yandex.ru.'],
    ],
  },
  terms: {
    title: 'Условия использования',
    intro: 'Основные правила работы с платформой рыночной экспресс-оценки ЗЕМА.',
    sections: [
      ['Назначение сервиса', 'ЗЕМА формирует предварительную рыночную оценку коммерческой недвижимости на основании доступных сведений и сопоставимых предложений.'],
      ['Характер результата', 'Расчёт носит информационный характер и не заменяет официальный отчёт оценщика, юридическую или инвестиционную консультацию.'],
      ['Ответственность пользователя', 'Пользователь отвечает за достоверность введённых сведений, сохранность доступа к аккаунту и законность использования полученных материалов.'],
      ['Доступность', 'Состав функций и источников может меняться. При существенных изменениях условий актуальная редакция публикуется на этой странице.'],
    ],
  },
};

export default function LegalPage({ type }) {
  const document = documents[type] || documents.privacy;
  return (
    <main className="zema-legal zema-public">
      <header className="zema-legal-hero">
        <img className="zema-legal-city" src="/images/zema-city.webp" alt="" aria-hidden="true" />
        <div className="zema-wrap">
          <Link to="/" className="zema-legal-back"><ArrowLeftOutlined /> На главную</Link>
          <h1>{document.title}</h1>
          <p>{document.intro}</p>
          <span>Редакция от 21 сентября 2026 года</span>
        </div>
      </header>
      <div className="zema-legal-layout zema-wrap">
        <aside aria-label="Юридические документы">
          <Link to="/privacy">Конфиденциальность</Link>
          <Link to="/consent">Обработка данных</Link>
          <Link to="/terms">Условия использования</Link>
        </aside>
        <article>
          {document.sections.map(([title, body]) => <section key={title}><h2>{title}</h2><p>{body}</p></section>)}
          <div className="zema-legal-contact"><strong>Нужна дополнительная информация?</strong><a href="mailto:Voronova.anastasiya99@yandex.ru">Voronova.anastasiya99@yandex.ru</a></div>
        </article>
      </div>
    </main>
  );
}
